import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { FC } from "react";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

interface MonthPickerProps {
  selectedMonth: number;
  selectedYear: number;
  onMonthChange: (month: number, year: number) => void;
  earliestSelectableDate?: Date;
}

export const MonthPicker: FC<MonthPickerProps> = ({
  selectedMonth,
  selectedYear,
  onMonthChange,
  earliestSelectableDate = new Date(Date.UTC(0, 0, 1)),
}) => {
  const theme = useTheme();

  const handlePrevMonth = () => {
    if (selectedMonth === 0) {
      onMonthChange(11, selectedYear - 1);
    } else {
      onMonthChange(selectedMonth - 1, selectedYear);
    }
  };

  const handleNextMonth = () => {
    if (selectedMonth === 11) {
      onMonthChange(0, selectedYear + 1);
    } else {
      onMonthChange(selectedMonth + 1, selectedYear);
    }
  };

  const prevMonth = selectedMonth === 0 ? 11 : selectedMonth - 1;
  const prevMonthYear = selectedMonth === 0 ? selectedYear - 1 : selectedYear;
  const lastDayOfPrevMonth = new Date(
    Date.UTC(prevMonthYear, prevMonth + 1, 0),
  );
  const isPrevMonthDisabled = lastDayOfPrevMonth < earliestSelectableDate;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 6,
        py: 2,
      }}
    >
      <IconButton
        disabled={isPrevMonthDisabled}
        onClick={handlePrevMonth}
        size="small"
        sx={{
          color: theme.colors.primary[5],
        }}
      >
        <ChevronLeft />
      </IconButton>

      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          color: theme.colors.text[5],
          userSelect: "none",
        }}
      >
        {MONTH_NAMES[selectedMonth]} {selectedYear}
      </Typography>

      <IconButton
        onClick={handleNextMonth}
        size="small"
        sx={{
          color: theme.colors.primary[5],
        }}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};
